import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const FreeTierIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M20.5714 12C20.5714 16.7339 16.7339 19.5 12 19.5C7.26613 19.5 3.42857 16.7339 3.42857 12C3.42857 7.26613 7.26613 4.5 12 4.5C16.7339 4.5 20.5714 7.26613 20.5714 12Z"
        fill="var(--cdl-bg-base)"
      />
      <path
        d="M19.5 12C19.5 8.05511 15.9449 4.5 12 4.5C8.05511 4.5 4.5 8.05511 4.5 12C4.5 15.9449 8.05511 19.5 12 19.5C15.9449 19.5 19.5 15.9449 19.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        fill="currentColor"
      />
      <path
        d="M13.4286 12C13.4286 12.789 12.789 13.4286 12 13.4286C11.211 13.4286 10.5714 12.789 10.5714 12C10.5714 11.211 11.211 10.5714 12 10.5714C12.789 10.5714 13.4286 11.211 13.4286 12Z"
        fill="var(--cdl-accent-fg-base)"
      />
      <path
        d="M9.14286 12C9.14286 10.422 10.422 9.14286 12 9.14286C13.578 9.14286 14.8571 10.422 14.8571 12C14.8571 13.578 13.578 14.8571 12 14.8571C10.422 14.8571 9.14286 13.578 9.14286 12Z"
        fill="var(--cdl-accent-fg-base)"
      />
    </svg>
  );
};

export default FreeTierIcon;
